import FragmentPage from '../core/FragmentPage';
import { initResponsiveSlides } from '../services/slider';

export default class ContactoPage extends FragmentPage {
  constructor(meta) {
    super('contacto', meta);
  }

  async onEnter() {
    initResponsiveSlides({ auto: true });
  }
}
